<template>
  <modal
        v-if="splitNode"
        ref="modal"
        id="agSplitModal"
        class="modal-container"
        styles="display:flex; flex-direction:column; padding:15px;"
        :draggable=true
        :resizable=true
        v-model="showSplitModal"
        name="splitNodeModal"
        drag="drag"
        content-class="modal-content"
        resize="resize"
        width="50%"
        height="85%"
        :shiftX=.5
        :shiftY=0
        :fit-parent="true"
        :resize-directions="['br']"
        :clickToClose="false"
        :key="reload"
        @keyup.enter.native="saveButton_click"
        >
        <div class="header">
          <h4 v-if="disableUI" class="agModal-title">View Split</h4>
          <h4 v-else class="agModal-title">Edit Split</h4>
          <hr/>
        </div>
        <div class="inner" style="height: 100%; overflow-y: auto; overflow-x:hidden; position:relative;">
        <div class="agInputGroup agInputGroupCentered">
      <label>Source:</label>
      <b-input type="text" v-model="srcStr" autocomplete="false" disabled></b-input>
    </div>
    <b-input-group size="md" style="padding:14px;" prepend="Name">
      <b-input type="text" v-model="agSplit.name" autocomplete="false" :disabled="disableUI"></b-input>
    </b-input-group>
    <b-input-group size="md" style="padding:14px;" prepend="Description">
      <b-input type="text" v-model="agSplit.description" autocomplete="false" :disabled="disableUI"></b-input>
    </b-input-group>
    <hr />
    <div>
      <div v-for="(agPath, index) in agSplit.paths" :key="index" class="agSplitModal-path">
              <div style="display:flex; justify-content:center;">
                  <label class="agSplitModal-pathLabel">Path {{index + 1}} Label:</label>
              </div>
              <b-input :key="'paths-' + index + '-' + reloadPaths" :value="agPath.label" @change="savePathName($event,index)" maxlength=15 class="agSplitModal-pathLabelText"></b-input>       
            <button
              class="agSplitModal-deletePathButton agDeleteButton agTextButton"
              :disabled="disableUI"
              @click="deletePathButton_click(index)">
              Delete
            </button>
      </div>
    </div>
    <button
      id="agSplitModal-addPathButton"
      class="agTextButton"
      :disabled="disableUI"
      @click="addPathButton_click">
      Add Path
    </button>    
    <div v-if="modalMessage">
      <hr />
      <label class="agModal-message" :class="modalMessageClass">{{modalMessage}}</label>
    </div>
    </div>
    <div>
    <hr/>
      <b-button class="agModal-buttonLeft" @click="cancelButton_click">Cancel</b-button>
      <b-spinner v-if="isLoading" class="agModal-loadingSpinner"></b-spinner>
      <b-button
        class="agModal-buttonRight"
        variant="danger"
        :disabled="disableUI || isLoading"
        @click="deleteButton_click"
        style="margin-left:82%;"
      >Delete</b-button>
      <b-button
        class="agModal-buttonRight"
        variant="primary"
        :disabled="disableUI || isLoading"
        @click="saveButton_click"
        style="float: right;"
      >Save</b-button>
    </div>

    <!-- delete modal -->
    <b-modal
      class="agModal"
      ref="deleteModal"
      centered
      no-close-on-esc
      no-close-on-backdrop
      @keyup.enter.native="deleteButton_click">
      <template slot="modal-header">
        <h4 class="agModal-title danger">Delete Split</h4>
      </template>
      Are you sure you want to delete split
      <i>{{name}}</i>?
      <template slot="modal-footer" slot-scope="{cancel}">
        <b-button class="agModal-buttonLeft" @click="cancel">Cancel</b-button>
        <b-button
        class="agModal-buttonRight"
        variant="danger"
        @click="confirmDeleteButton_click"
        >Delete</b-button>
      </template>
    </b-modal>
    </modal>
</template>


<script>
// components
import InputSelect from "comp/ui/InputSelect";

// modules
import Util from "src/util/util";
import { randomBytes } from "crypto";
import _ from 'lodash';

export default {
  name: "ag-split-modal",
  props: {
    node: Object,
    workflow: Object,
    disableUI: Boolean
  },
  components: {
  },
  data() {
    return {
      showSplitModal: false,
      reload:0,
      splitNode:false,
      agSplit: null,
      reloadPaths: 0,
      isLoading: false,
      modalMessage: "",
      modalMessageClass: ""
    };
  },
  computed: {

    name() {
      if (this.agSplit.name) {
        return this.agSplit.name;
      }
      return this.agSplit.shortname;
    },

    srcStr() {
      if (!this.agSplit.src || this.agSplit.src.length == 0) return "";

      var srcStr = "";
      for (var i = 0; i < this.agSplit.src.length; i++) {
        var src = this.agSplit.src[i];
        srcStr += src.shortname + ", ";
      }
      srcStr = srcStr.substring(0, srcStr.length - 2); // remove the last ,
      return srcStr;
    }
  },
  watch: {

  },

  mounted() {},

  methods: {
    // UI Events
    savePathName(e,index){
        this.agSplit.paths[index].label = e; 
    },
    addPathButton_click(){
        var agPath = {
            label: null,
            dest: null
        }
        this.agSplit.paths = Util.insertInArray(
            this.agSplit.paths, this.agSplit.paths.length,
            agPath
        )
        this.reloadPaths++
    },
    deletePathButton_click(index) {
      this.agSplit.paths = Util.removeFromArrayByIndex(
        this.agSplit.paths,
        index
      );
      this.reloadPaths++;
    },
    
    async saveButton_click() {
      this.modalMessage = "";
      var node = {
        object: this.agSplit,
        type: "splitNode"
      };
      this.isLoading = true;
      var result = await this.$store.dispatch("nodeStore/updateNode", {
        node: node
      });
      this.isLoading = false;
      if (result.data.success) {
        var updated = {
          type: "splitNode",
          object: result.data.node
        };
        this.hide();
        this.$emit("updatedNode", updated);
      } else {
        this.modalMessage = result.data.error;
        this.modalMessageClass = "agModal-errorMessage";
      }
    },

    cancelButton_click() {  
        this.$modal.hide('splitNodeModal');
        this.splitNode = false;
      },

    deleteButton_click() {
      this.$refs.deleteModal.show();
    },

    async confirmDeleteButton_click() {
      this.$refs.deleteModal.hide();
      var node = {
        object: this.agSplit,
        type: "splitNode"
      };
      this.isLoading = true;
      var result = await this.$store.dispatch("nodeStore/deleteNode", {
        node: node
      });
      this.$emit("deletedNode", node);
      this.isLoading = false;
      this.hide();
    },

    // emitted events

    // other
    show() {
      this.setSplit();
      this.splitNode = true;
      setTimeout(() => {
        this.$modal.show('splitNodeModal',{ draggable: true });
        this.reset();
      }, 250);
    },

    hide() {
      this.$modal.hide('splitNodeModal');
      this.splitNode = false;    },

    reset() {
      this.modalMessage = "";
      this.modalMessageClass = "";
      this.errorField = "";
    },

    setSplit() {
      if(this.node && this.node.type == "splitNode") 
        this.agSplit = this.workflow.splitNodes.find((object) => object._id == this.node.object._id);
      else
        this.agSplit = null;
    },


    getNameForDest(dest) {
      if (dest) return dest.shortname;
      return "";
    },

  }
};
</script>


<style scoped lang="css">

.agSplitModal-pathLabel{
  font-weight: bold;
  color: gray;
}
.agSplitModal-pathLabelText {
  width:200px;
  height:30px; 
  margin-left: 2%;
}

.agSplitModal-path{
  margin-top: 10px;
  margin-bottom: 15px;  
  display:flex; 
  justify-content: center;
}

.agSplitModal-deletePathButton{
  position: relative;
  left: 25px;
  font-size: 16px;
}

.agSplitModal-addPathButton{
  display: block;
  margin: 25px auto;
  font-size: 18px;
}

</style>


// WEBPACK FOOTER //
// src/components/nodes/SplitModal.vue